<app-patient-documents-flow
  [mode]="mode"
  [patientID]="patientID"
  [patientFromParent]="patientFromParent">
</app-patient-documents-flow>
